import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useLoyalty() {
  const [points, setPoints] = useState(0);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [bookingsCount, setBookingsCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { setLoading(false); return; }

      const [pointsRes, txnRes, bookingRes] = await Promise.all([
        supabase.from("loyalty_points").select("points").eq("user_id", user.id).maybeSingle(),
        supabase.from("loyalty_transactions").select("*").eq("user_id", user.id).order("created_at", { ascending: false }).limit(50),
        supabase.from("bookings").select("id", { count: "exact", head: true }).eq("user_id", user.id).eq("status", "completed"),
      ]);

      setPoints(pointsRes.data?.points ?? 0);
      setTransactions(txnRes.data ?? []);
      setBookingsCount(bookingRes.count ?? 0);
      setLoading(false);
    })();
  }, []);

  const tier = bookingsCount >= 20 ? "Gold" : bookingsCount >= 5 ? "Silver" : "Bronze";

  return { points, transactions, tier, bookingsCount, loading };
}
